// removed by extract-text-webpack-plugin
module.exports = {"cardBody":"src-pageComponents-home-components-aboutCard----aboutCard-module---cardBody---1Mp2y","sectionHeader":"src-pageComponents-home-components-aboutCard----aboutCard-module---sectionHeader---3g4Tv","sectionContent":"src-pageComponents-home-components-aboutCard----aboutCard-module---sectionContent---4K8tC"};


//////////////////
// WEBPACK FOOTER
// ./src/pageComponents/home/components/aboutCard/aboutCard.module.css
// module id = 410
// module chunks = 213534597649335